export default __webpack_public_path__ + "static/media/exteriorFinalizat4_2019.cb207bea.jpeg";